import { normalizePreviewIdentifier } from "../identifier";
import type { PreviewEntityType, ResolvedPreviewTarget } from "./types";

const DEFAULT_ENTITY_TYPE: PreviewEntityType = "isbn";

const ROUTE_SEGMENT_BY_TYPE: Record<string, string> = {
  isbn: "manifestation",
  manifestation: "manifestation",
  collection: "collection",
  contributor: "contributor",
};

function normalizeIdentifierByType(
  identifier: string,
  routeSegment: string,
): string {
  if (routeSegment === "manifestation") {
    return normalizePreviewIdentifier(identifier);
  }

  return identifier.trim();
}

export function resolvePreviewTarget(
  rawValue: string,
  explicitType?: PreviewEntityType,
): ResolvedPreviewTarget | undefined {
  const trimmedValue = rawValue.trim();

  if (!trimmedValue) {
    return undefined;
  }

  let type = explicitType ?? DEFAULT_ENTITY_TYPE;
  let identifier = trimmedValue;

  if (!explicitType) {
    const separatorIndex = trimmedValue.indexOf(":");

    if (separatorIndex > 0) {
      type = trimmedValue.slice(0, separatorIndex).trim().toLowerCase();
      identifier = trimmedValue.slice(separatorIndex + 1).trim();
    }
  }

  const routeSegment = ROUTE_SEGMENT_BY_TYPE[type] ?? type;
  const normalizedIdentifier = normalizeIdentifierByType(
    identifier,
    routeSegment,
  );

  if (!normalizedIdentifier) {
    return undefined;
  }

  return {
    type,
    routeSegment,
    identifier,
    normalizedIdentifier,
    cacheKey: `${routeSegment}:${normalizedIdentifier}`,
    attributeValue: trimmedValue,
  };
}
